var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"layout-documents"},[_c('h1',{staticClass:"layout-documents__headline",domProps:{"textContent":_vm._s(_vm.title)}}),_c('section',{staticClass:"layout-documents__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }